import { render, staticRenderFns } from "./comeback.vue?vue&type=template&id=d13e152e&scoped=true&"
import script from "./comeback.vue?vue&type=script&lang=js&"
export * from "./comeback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e152e",
  null
  
)

export default component.exports